import type { AvatarsSubtitleStyle } from '../modules/avatars/types/subtitles';
import { MACRO_AVATARS_SUBTITLE_STYLE } from './MACRO/avatars/subtitles';
import { TEST_AVATARS_SUBTITLE_STYLE } from './TEST/avatars/subtitles';

/**
 * Registry de estilos de subtítulos de Avatars por cliente. Centralizado para
 * que el editor resuelva el estilo sin saber qué clientes existen ni acoplarse
 * a sus paths (paridad con `avatars-placas-registry.ts`).
 *
 * Agregar un cliente nuevo:
 *   1. Crear `clients/<CLIENT_ID>/avatars/subtitles.ts` con la config tipada.
 *   2. Importar y sumar al `REGISTRY` debajo.
 *
 * Si un cliente no está en el registry, `buildScenesCanvasJSON` cae en el estilo
 * default hardcoded — cero riesgo de romper el editor para clientes nuevos.
 */
const REGISTRY: Record<string, AvatarsSubtitleStyle> = {
  MACRO: MACRO_AVATARS_SUBTITLE_STYLE,
  TEST: TEST_AVATARS_SUBTITLE_STYLE
};

export const getAvatarsSubtitleStyle = (clientId: string): AvatarsSubtitleStyle | undefined =>
  REGISTRY[clientId];
